import axios from "axios";
import {TransactionSIX} from "@/api/types";
import getApiDomain from "@/api/getApiDomain";

const getTransactions = async (params?: any) => {
	const response = await axios.get<TransactionSIX[]>(getApiDomain() + "/api/transactionlog", {
		headers: {
			'X-HTTP-AUTHORIZATION': `Authenticate ${localStorage.getItem("auth_token")}`,
			'Access-Control-Allow-Origin': '*',
		},
		params: params
	}).catch(function (e) {
		const error = e.toJSON();
		if(error.status !== 500){
			throw e;
		}
	});
	if(!response){
		return [];
	}
	return response.data.map((transaction:TransactionSIX) => {
		if(transaction.type === "Gutschrift"){
			transaction.amount = transaction.amount * -1;
		}

		return transaction;
	});
};

export default getTransactions;
